import { render, staticRenderFns } from "./GenderDOB.vue?vue&type=template&id=d9e39fe2"
import script from "./GenderDOB.vue?vue&type=script&lang=js"
export * from "./GenderDOB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports